import React, { ChangeEvent } from 'react'

let syntheticIdSuffix = 0

interface TextFieldProps {
  defaultValue?: string
  disabled?: boolean
  errorMessage?: string
  helperText?: string
  id?: string
  label: string
  name?: string
  onChange?: Function
  required?: boolean
  type?: 'date' | 'email' | 'number' | 'text'
  value?: string
  valid?: boolean
}

const TextField = ({
  helperText,
  defaultValue,
  disabled = false,
  errorMessage = 'Vous devez renseigner un texte',
  id,
  label,
  name,
  onChange,
  required = false,
  type = 'text',
  value,
  valid = true,
}: TextFieldProps) => {
  const descriptionId = helperText
    ? `description-input-${id || ++syntheticIdSuffix}`
    : null

  const dynamicLabelProps = descriptionId
    ? { 'aria-describedby': descriptionId }
    : {}
  const dynamicInputProps: any = {}
  if (defaultValue != null) {
    dynamicInputProps.defaultValue = defaultValue
  }
  if (value != null) {
    dynamicInputProps.value = value
  }
  if (typeof onChange === 'function') {
    dynamicInputProps.onChange = ({
      target: { value },
    }: ChangeEvent<HTMLInputElement>) => onChange(value.trim())
  }

  return (
    <div className='u-mb-2'>
      <label
        className='c-label c-label--image'
        htmlFor={id}
        {...dynamicLabelProps}
      >
        {label}
      </label>
      <input
        aria-required={required}
        aria-invalid={!valid}
        disabled={disabled}
        id={id}
        name={name}
        type={type}
        {...dynamicInputProps}
      />
      {!valid && <p className='c-message c-message--error'>{errorMessage}</p>}
      {descriptionId && (
        <p id={descriptionId} className='c-message c-message--help'>
          {helperText}
        </p>
      )}
    </div>
  )
}

export default TextField
